import React, { useState } from 'react';
import { DataGridPro } from '@mui/x-data-grid-pro';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';

export default function Table({ loading, tableHeaders, productAllocations }) {
  const headers = tableHeaders?.map((item) => ({
    field: `alloc_count_${item.product_id}`,
    headerName: item.product_name,
    width: 200,
    headerClassName: 'super-app-theme--header',
    renderCell: ({ value }) =>
      Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(value),
  }));

  const [sortModel, setSortModel] = useState([
    {
      field: 'id',
      sort: 'desc',
    },
  ]);

  const columns = [
    {
      field: 'head_name',
      headerName: 'RSM',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'manager_name',
      headerName: 'Manager',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'rep_name',
      headerName: 'MPR',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_code',
      headerName: 'MD Code',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_name',
      headerName: 'MD Name',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'md_group',
      headerName: 'MD Group',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'specialty',
      headerName: 'Specialty',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
    },
    {
      field: 'target',
      headerName: 'Frequency',
      width: 200,
      cellClassName: ({ row }) => `cell-row-${row.id}`,
      headerClassName: 'super-app-theme--header',
      renderCell: ({ row }) =>
        Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(row.target),
    },
    ...headers,
  ];

  const pinnedRows = {
    top: productAllocations.length ? [productAllocations[0]] : [],
  };

  return (
    <div>
      <Grid container spacing={2}>
        <Grid xs={12} sm={12} md={12}>
          <Box
            className='table-container'
            sx={{
              height: '800px',
              marginLeft: '20px',

              '& .MuiDataGrid-pinnedRows': { fontWeight: 'bold', backgroundColor: '#5cb85c' },
              '& .cell-row-0': { fontWeight: 'bold', backgroundColor: '#5cb85c' },
            }}
          >
            &nbsp;
            <DataGridPro
              loading={loading}
              rows={productAllocations}
              columns={columns}
              sortModel={sortModel}
              pinnedRows={pinnedRows}
              experimentalFeatures={{ rowPinning: true }}
              initialState={{
                ...productAllocations.initialState,
                pagination: { paginationModel: { pageSize: 50 } },
                pinnedColumns: { left: ['head_name', 'manager_name', 'rep_name'], right: [] },
              }}
              pageSizeOptions={[50, 75, 100]}
              pagination
              onSortModelChange={(model) => setSortModel(model)}
            />
          </Box>
        </Grid>
      </Grid>
    </div>
  );
}
